import * as firebaseMessaging from "firebase/messaging";

export function isNotificationsSupported() {
  return "Notification" in window;
}

export async function isFirebaseMessagingSupported() {
  return await firebaseMessaging.isSupported();
}

export async function requestNotificationsPermission() {
  return await Notification.requestPermission();
}
